var aviator = new Aviator({requireFonts: true});